import React, { useState, useEffect } from 'react'
import Loader from 'react-loader-spinner'
import { FaSpinner } from "react-icons/fa";
import { Modal } from 'react-bootstrap';
import Table from 'react-bootstrap/Table'
import { MdCancel } from 'react-icons/md'
import { getAllAssignToOtherVioDetail } from '../../../common/apiService';

export default function AssignToOtherViolation({ violationData, totalCount, loading, globalJsonData }) {
    const [amount, setAmount] = useState(0);
    const [violationCount, setViolationCount] = useState(0);
    const [jsonData, setjsonData] = useState({});
    const [showModel, setShowModel] = useState(false);
    const [totalGridData, setTotalGridData] = useState([]);
    const [gridLoader, setGridLoader] = useState(false);

    useEffect(() => {
        const data = violationData;
        if (data.cases) {
            setViolationCount(data.cases);
            setAmount(data.sumAmount);
        } else {
            setViolationCount(0);
            setAmount(0);
        }
        setjsonData(globalJsonData);
    }, [violationData]);

    const getGridData = async () => {
        setShowModel(true);
        setGridLoader(true)
        try {
            let { data } = await getAllAssignToOtherVioDetail(jsonData);
            setTotalGridData(data);
            setGridLoader(false);
        } catch {
            setTotalGridData(0);
           setTimeout(()=>setGridLoader(false),1000);
        }
    }

    return (
        <>
            <div style={{ position: 'relative' }}>
                <div className='other-violence-block' style={{ paddingTop: 15 }}>
                    <Loader className="loader"
                        type="ThreeDots"
                        color="#9c1d26"
                        height={30}
                        width={100}
                        visible={loading}
                    />
                    <p className="title" style={{ color: "#707070" }}><b>{"Violation assigned to other plaza users"}</b></p>
                    <p className="count" style={{ color: "#303A78", fontSize: 50 }} >{violationCount}</p>
                    <button className="viewdetailbtn" onClick={getGridData} >View details {loading && <FaSpinner style={{ marginRight: '-8px' }} icon="spinner" spin className="spinner" />}  </button>
                </div>
            </div>
            <Modal show={showModel} size="lg" className="actionVioationModel" onHide={() => setShowModel(false)}>
                <Loader className="loader"
                type="ThreeDots"
                color="#9c1d26"
                height={30}
                width={100}
                visible={gridLoader}
                style={{top:'50%'}}
            />
                <div style={{ margin: 20 }}>
                    <div className="flexbox">
                        <div><p style={{ color: '#131523', fontSize: 20 }}>Violations details for Assign To Others</p></div>
                        <div style={{ textAlign: 'right' }}><MdCancel style={{ fontSize: 35, color: '#7c7c7c', cursor: 'pointer' }} onClick={() => setShowModel(false)} /></div>
                    </div>
                    <br />
                </div>
                <Modal.Body className="">
                    <div style={{ maxHeight: 500, overflow: 'auto', width: '100%' }}>
                        <Table variant="light" className="customTable searchGridTable violation-detail-table" >
                            <thead>
                                <tr style={{ position: 'sticky', top: -1 }}>
                                    <th width="350px" >User Name</th>
                                    <th width="350px" >Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {totalGridData.length > 0 ?
                                    totalGridData.map((e, index) => {
                                        return (
                                            <tr>
                                                <td style={{ color: '#131523' }}>{e.plazaUsers}</td>
                                                <td style={{ color: '#131523' }}>{e.cases}</td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td style={{ color: '#131523' }} colSpan="2" style={{ textAlign: 'center' }}>Data Not Found!</td>
                                    </tr>
                                }

                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}
